import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Services = () => {
  const { t } = useLanguage();

  const services = [
    {
      key: 'family',
      image: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9',
      title: t.services.family.title,
      description: t.services.family.description
    },
    {
      key: 'inheritance',
      image: 'https://images.unsplash.com/photo-1687289133469-b2a07a13b78b',
      title: t.services.inheritance.title,
      description: t.services.inheritance.description
    },
    {
      key: 'property',
      image: 'https://images.unsplash.com/photo-1759429255330-51145b170dad',
      title: t.services.property.title,
      description: t.services.property.description
    },
    {
      key: 'business',
      image: 'https://images.unsplash.com/photo-1619418602850-35ad20aa1700',
      title: t.services.business.title,
      description: t.services.business.description
    },
    {
      key: 'criminal',
      image: 'https://images.unsplash.com/photo-1589391886645-d51941baf7fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxjcmltaW5hbCUyMGxhdyUyMGdhdmVsfGVufDB8fHx8MTc2MjcwMjY5Nnww&ixlib=rb-4.1.0&q=85',
      title: t.services.criminal.title,
      description: t.services.criminal.description
    },
    {
      key: 'consulting',
      image: 'https://images.unsplash.com/photo-1760089449852-e8cade7feb53',
      title: t.services.consulting.title,
      description: t.services.consulting.description
    }
  ];

  return (
    <section id="services" className="section-padding services-section">
      <div className="container">
        <h2 className="heading-1 section-title">{t.services.title}</h2>
        
        <div className="grid-product-showcase">
          {services.map((service) => (
            <div key={service.key} className="product-card">
              <img 
                src={service.image} 
                alt={service.title}
                className="product-card-image"
              />
              <h3 className="product-card-title">{service.title}</h3>
              <p className="product-card-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;